<template>
  <div>
    <div class="row">
      <div class="col-md-7">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
          {{ Dates(datas.created_at) }}
          <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
            class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
        </h4>
      </div>
      <div class="col-md-3" style="display: flex;">
        <label for="">Курс</label>
        <input type="text" :disabled="changedisabled" v-model="datas.dollar_rate" class="kurs">
      </div>
      <div class="col-md-2 end">
        <router-link class="btn btn-danger" :to="{ path: '/initial/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">
      <div class="col-md-1 topheader">
        <span>
          <label for="">Факт №</label>
          <input type="number" :disabled="changedisabled" class="input100" v-model="datas.number">
        </span>
      </div>
      <!-- <div class="col-md-2 topheader">
        <span>
          <label>{{ $t("Вақт") }}</label>
          <input :disabled="changedisabled" v-model="datas.create_time" type="date">
        </span>
      </div> -->
      <div class="col-md-3 topheader">
        <span>
          <label>Склад</label>
          <v-select :disabled="skladhave" :clearable="false" class="form-control-sm required md-input"
            :options="skladlist" v-model="datas.sklad_id" :reduce="name => name.id" label="name">
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" ref="focused" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>{{ $t("Тўлов тури") }}</label>
          <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input"
            :options="paytypelist" v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
            <template #list-footer>
              <li style="text-align: center;font-weight:bold;">
                f4 {{ $t("умумий рўйхат") }}
              </li>
            </template>
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
              <button :disabled="changedisabled" type="button" class="modallist" v-b-modal.modal-paytypelist>
                <b-icon icon="three-dots"></b-icon>
              </button>
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-4 topheader">
        <span>
          <label>Комментарий</label>
          <input :disabled="changedisabled" v-model="datas.comment" class="needt" type="text">
        </span>
      </div>
    </div>
    <div class="tableparentdiv">
      <input type="text" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')" v-model="filter2"
                ref="focused2" />
      <table class="create_table" style="overflow: hidden;">
        <thead>
          <tr style="display: grid; min-width: 2000px; grid-template-columns: 5% 9% 17% 5% 5% 6% 6% 6% 5% 6% 6% 5% 7% 7% 4%;">
            <th v-if="settings[0].view==true">№</th>
            <th v-if="settings[1].view==true">Штрих код</th>
            <th v-if="settings[2].view==true">Товар</th>
            <th v-if="settings[3].view==true">{{ $t("Cони") }}</th>
            <th v-if="settings[13].view==true">{{$t(settings[13].column)}}</th>
            <th v-if="settings[4].view==true">{{ $t("Нарх") }} ({{ $t("Кирим") }})</th>
            <th v-if="settings[5].view==true">Сумма ({{ $t("Кирим") }})</th>
            <th v-if="settings[14].view==true">{{$t(settings[14].column)}}</th>
            <th v-if="settings[6].view==true">{{ $t("Чакана") }}(%)</th>
            <th v-if="settings[7].view==true">{{ $t("Чакана") }} ({{ $t("Нарх") }})</th>
            <th v-if="settings[8].view==true">{{ $t("Чакана") }} ({{ $t("Нарх") }})$</th>
            <th v-if="settings[9].view==true">{{ $t("Улгуржи") }} (%)</th>
            <th v-if="settings[10].view==true">{{ $t("Улгуржи") }} ({{ $t("Нарх") }})</th>
            <th v-if="settings[11].view==true">{{ $t("Улгуржи") }} ({{ $t("Нарх") }})$</th>
            <th v-if="settings[12].view==true"></th>
          </tr>
        </thead>
        <tbody style="overflow: hidden;">
          <VueAutoVirtualScrollList :totalHeight="500" class="virtual" :defaultHeight="50"
            style="width: 1985px ;height: 62vh!important;overflow-y: scroll;">
            <tr style="display: grid; min-width: 2000px; grid-template-columns: 5% 9% 17% 5% 5% 6% 6% 6% 5% 6% 6% 5% 7% 7% 4%;" v-for="(item, index) in prsearch" :key="index">
               <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[0].view==true">{{ index + 1 }}</td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[1].view==true">
                <input :disabled="changedisabled" class="table-input" type="text" v-model="item.shtrix_kod"
                  @change="Shtrix(index)" />
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[2].view==true">
                <v-select style="width: 100%; padding-top: 2px !important;" :disabled="changedisabled" v-if="productlist != null" :filter-by="$store.state.myFilter"
                  :clearable="false" class="form-control-sm required" @search="query => (search = query)"
                  :options="paginated" menu-props="auto" v-model="item.product_id" :reduce="extra_name => extra_name.id"
                  label="extra_name" @input="Productchange(index)">
                  <template #list-footer>
                    <li style="text-align: center;font-weight:bold;">
                      f4 {{ $t("умумий рўйхат") }}
                    </li>
                  </template>
                  <template #selected-option-container="{option}">
                    <div class="vs__selected">
                      <span v-if="typeof option.extra_name === 'number'">{{
                        Label(option.extra_name)
                        }}</span><span v-else>{{ option.extra_name }}</span>
                    </div>
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"></span>
                    <button :disabled="changedisabled" type="button" class="modallist" @click="Selectproduct(index)">
                      <b-icon icon="three-dots"></b-icon>
                    </button>
                  </template>
                  <template #selected-option="{ extra_name }">
                    <div style="position: absolute">
                      {{ extra_name }}
                    </div>
                  </template>
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      <em><b>{{ search }}</b></em>
                      {{ $t("бўйича маьлумот йўқ") }}
                      <button :disabled="changedisabled" type="button" class="pluss"
                        @click="CreateProduct(index, search)">
                        +</button><b>Insert</b>
                    </template>
                    <em style="opacity: 0.5" v-else>{{
                      $t("Маьлумот йўқ")
                      }}</em>
                  </template>
                  <template #search="{ search, searching }">
                    <template v-if="searching">
                      <em><b>{{ search }}</b></em>
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                    </template>
                  </template>
                </v-select>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[3].view==true">
                <vue-numeric :disabled="changedisabled" separator="space" v-model="item.count" class="table-input"
                  @change="Changecount(index)" v-bind:precision="3">
                </vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[13].view==true">
                <vue-numeric :disabled="changedisabled" separator="space" style="text-align: center;" v-bind:precision="3" v-model="item.pack_count"
                class="table-input" @blur="Changepack(index)"></vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[4].view==true">
                <vue-numeric :disabled="changedisabled" separator="space" style="text-align: center;"
                  v-model="item.debit_price" class="table-input" @blur="Changeprice(index)" v-bind:precision="2">
                </vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[5].view==true">
                {{ item.debit_summa | numFormat }}
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[14].view==true">
                <vue-numeric :disabled="changedisabled" separator="space" v-bind:precision="3" style="text-align: center;"
                  v-model="item.pack_price" class="table-input" @blur="Changepackprice(index)"></vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[6].view==true">
                <input :disabled="changedisabled" separator="space" style="text-align: center;"
                  v-model="item.chakana_percent" class="table-input" type="text" @blur="Changepercentchakana(index)"
                  v-bind:precision="0">
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[7].view==true">
                <vue-numeric :disabled="changedisabled" separator="space" style="text-align: center;"
                  v-model="item.chakana_price" class="table-input" @blur="Changepricechakana(index)"
                  v-bind:precision="2">
                </vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[8].view==true">
                <vue-numeric :disabled="changedisabled" separator="space" style="text-align: center;"
                  v-model="item.chakana_dollar_price" class="table-input" @blur="Changepricechakanadollar(index)"
                  v-bind:precision="2">
                </vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[9].view==true">
                <input type="text" :disabled="changedisabled" separator="space" style="text-align: center;"
                  v-model="item.optom_percent" class="table-input" @blur="Changepercentoptom(index)"
                  v-bind:precision="0">
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[10].view==true">
                <vue-numeric  :disabled="changedisabled" separator="space" style="text-align: center;"
                  v-model="item.optom_price" class="table-input" @blur="Changepriceoptom(index)" v-bind:precision="2">
                </vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[11].view==true">
                <vue-numeric :disabled="changedisabled" separator="space" style="text-align: center;"
                  v-model="item.optom_dollar_price" class="table-input" @blur="Changepriceoptomdollar(index)"
                  v-bind:precision="2">
                </vue-numeric>
              </td>
              <td style="display: flex; justify-content: center; align-items: center; padding: 3px !important;" v-if="settings[12].view==true">
                <a v-if="changedisabled==false" href="javascript:void(0)" class="circul trash"
                  @click="Trashitem(index)">
                  <b-icon icon="trash"></b-icon>
                </a>
              </td>
            </tr>
          </VueAutoVirtualScrollList>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-1 topminus">
        <span>{{$t('Сони')}}</span>
        <h4>{{datas.count_all|numFormat}}</h4>
      </div>
      <div class="col-md-2 end topminus">
        <span>Сумма</span>
        <h4>{{datas.summa|numFormat}}</h4>
      </div>
      <div class="col-md-7 end formbottom">
        <button :disabled="changedisabled" class="addrow mybtn btn" type="button" @click="Addtable()"
          style="right:23vh!important;">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button :disabled="changedisabled" type="button" class="mybtn btn" v-b-modal.modal-settings>
          <b-icon icon="gear"></b-icon>
        </button>
        <button v-if="changedisabled==false" :disabled="sending" class="btn mybtn" id="chek" type="button"
          @click="Savedokument('barcode')">
          <b-icon icon="upc-scan"></b-icon><sup></sup>
        </button>
        <button v-if="changedisabled==false" type="button" class="btn mybtn" @click="onexport">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
        <button v-if="changedisabled==false" :disabled="sending" class="btn mybtn" id="a4print" type="button" @click="Savedokument('a4')">
          <b-icon icon="printer"></b-icon> A4
        </button>
        <button v-if="changedisabled==false" class="mybtn btn saved" :disabled="sending" type="button"
          @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
        </button>
      </div>
    </div>
    <b-modal id="modal-settings" hide-footer size="xl" @hidden="SaveSettings()">
      <div class="row">
        <table class="table table-bordered">
          <thead>
            <th>{{$t('Номи')}}</th>
            <th>{{$t('Кўрсатиш')}}</th>
            <th>{{$t('Ўлчами')}}</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in settings" :key="index">
              <td>{{$t(item.column)}}</td>
              <td>
                <input type="checkbox" v-model="item.view">
              </td>
              <td>
                <input type="number" v-model="item.width">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal id="modal-shtrix" title="Товар" hide-footer size="xl" @shown="Shoved" @hidden="Hide()">
      <div class="row">
        <input type="text" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')" v-model="filter"
          ref="inputText2" />
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t("Номи") }}</th>
              <th>{{ $t("Қолдиқ") }}</th>
              <th>{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
              <th>{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
              <th>Штрих</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in filteredRows" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <button type="button" class="atable" @click="
                    datas.initial_balance_table[settedindex].product_id =
                      item.product_id;
                    Productchange(settedindex);
                    $bvModal.hide('modal-shtrix');
                  ">
                  {{ item.name }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                    datas.initial_balance_table[settedindex].product_id =
                      item.product_id;
                    Productchange(settedindex);
                    $bvModal.hide('modal-shtrix');
                  ">
                  {{ item.balance }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                    datas.initial_balance_table[settedindex].product_id =
                      item.product_id;
                    Productchange(settedindex);
                    $bvModal.hide('modal-shtrix');
                  " v-if="item.price_register[0]">
                  {{ item.price_register[0].chakana_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                    datas.initial_balance_table[settedindex].product_id =
                      item.product_id;
                    Productchange(settedindex);
                    $bvModal.hide('modal-shtrix');
                  " v-if="item.price_register[0]">
                  {{ item.price_register[0].optom_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                    datas.initial_balance_table[settedindex].product_id =
                      item.product_id;
                    Productchange(settedindex);
                    $bvModal.hide('modal-shtrix');
                  " v-if="item.shtrix_table[0]">
                  {{ item.shtrix_table[0].shtrix_kod }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { print } from "../../components/mixins/print.js";
  import XLSX from "xlsx";
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import $ from "jquery";
  export default {
    name: "KirimForm",
    mixins: [print],
    data() {
      return {
        settings: [
          { 'column': '№', 'width': 70, 'view': true },
          { 'column': 'shtrix_kod', 'width': 120, 'view': true },
          { 'column': 'product_id', 'width': 300, 'view': true },
          { 'column': 'count', 'width': 100, 'view': true },
          { 'column': 'debit_price', 'width': 100, 'view': true },
          { 'column': 'debit_summa', 'width': 120, 'view': true },
          { 'column': 'chakana_percent', 'width': 100, 'view': true },
          { 'column': 'chakana_price', 'width': 100, 'view': true },
          { 'column': 'chakana_dollar_price', 'width': 100, 'view': true },
          { 'column': 'optom_percent', 'width': 100, 'view': true },
          { 'column': 'optom_price', 'width': 100, 'view': true },
          { 'column': 'optom_dollar_price', 'width': 100, 'view': true },
          { 'column': 'del', 'width': 70, 'view': true },
          { 'column': 'pack_count', 'width': 100, 'view': true },
          { 'column': 'pack_price', 'width': 100, 'view': true }
        ],
        filter2: "",
        shtrixlist: [],
        settedindex: null,
        sklad: "",
        paytype: "",
        limits: 100,
        filter: "",
        focusset: "",
        skladlist: [],
        paytypelist: [],
        sending: false
      };
    },
    props: ["datas"],
    components: { VueAutoVirtualScrollList },
    created: function () {
      let self = this;
      self.$root.$refs.initial = self;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
    },
    mounted: function () {
      let self = this;
      $(".virtual").scroll(function () {
        var scroll = $(this).scrollTop() + 1000;
        var height = $(this).prop("scrollHeight");
        if (scroll > height) {
          self.limits += 100;
        }
      });
      self.SetRule('/initial/index');
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          this.prsearch[
            this.$store.state.selected_index
          ].product_id = parseInt(localStorage.getItem("setted_product"));
          this.Productchange(this.$store.state.selected_index);
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }
      }),
      setTimeout(() => {
        localStorage.setItem("sklad_id_dok", this.datas.sklad_id);
        localStorage.setItem(
          "created_at_dok",
          this.Dates(this.datas.created_at)
        );
      }, 1000);
      this.Focus();
      this.Settings();
    },
    methods: {
      Settings() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'initial' }
        }).then(function (response) {
          if (response.data.data == null) {
            self.SaveSettings();
          } else {
            var value=JSON.parse(response.data.data);
            if(value.length<self.settings.length){
              for (let index = value.length; index < self.settings.length; index++) {
                value.push(self.settings[index]);
              }
            }
            self.settings = value;
          }
        });
      },
      SaveSettings() {
        let self = this;
        let stringsettings = JSON.stringify(self.settings);
        axios({
          method: "patch",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'initial', data: stringsettings }
        }).then(function (response) {
        });
      },
      onexport() {
        const myHeader = [
          "shtrix_kod",
          "product",
          "count",
          "debit_price",
          "debit_summa",
          "chakana_percent",
          "chakana_price",
          "optom_percent",
          "optom_price"
        ];
        var shtrix_kod = XLSX.utils.json_to_sheet(
          this.datas.initial_balance_table,
          { header: myHeader }
        );
        var wb = XLSX.utils.book_new();
        let self = this;
        shtrix_kod["A1"].v = "Штрих";
        shtrix_kod["B1"].v = "Товар";
        shtrix_kod["C1"].v = this.$t("Cони");
        shtrix_kod["D1"].v = this.$t("Нарх") + " " + this.$t("Кирим");
        shtrix_kod["E1"].v = "Сумма " + this.$t("Кирим");
        shtrix_kod["F1"].v = this.$t("Чакана") + " %";
        shtrix_kod["G1"].v = this.$t("Чакана") + " " + this.$t("Нарх");
        shtrix_kod["H1"].v = this.$t("Улгуржи") + " %";
        shtrix_kod["I1"].v = this.$t("Улгуржи") + " " + this.$t("Нарх");
        for (
          let index = 2;
          index < this.datas.initial_balance_table.length + 2;
          index++
        ) {
          if (self.datas.initial_balance_table[index - 2].product != null) {
            shtrix_kod["B" + index].v =
              self.datas.initial_balance_table[index - 2].product.extra_name;
          }
        }
        XLSX.utils.book_append_sheet(wb, shtrix_kod, "bosh_qoldiq");
        XLSX.writeFile(wb, new Date() + ".xlsx"); // name of the file is 'book.xlsx'
      },
      CreateProduct(index, search) {
        localStorage.setItem("product_name", search);
        localStorage.setItem("shtrix_code", this.prsearch[index].shtrix_kod);
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал create" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      updateItems(text) {
        yourGetItemsMethod(text).then(response => {
          this.$store.state.productlist = response;
        });
      },
      ChangedAndAdd(index) {
        if (this.datas.initial_balance_table.length == index + 1) {
          this.Addtable();
        }
      },
      Shoved() {
        let self = this;
        $(document).on("focusout", function (e) {
          if ($(e.target).attr("class") == "vs__search") {
            if (self.focusset == "") {
              self.focusset = e.target;
            }
          }
        });
        self.$refs.inputText2.focus();
      },
      Hide() {
        let self = this;
        setTimeout(function (e) {
          var classs = $(":focus");
          var rrr = $("body")
            .find("input,select,textarea,button")
            .filter(":visible");
          if (classs.attr("class") == "vs__search") {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              var focused = rrr.eq(rrr.index(classs) + 2);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          } else if (classs.attr("class") == undefined) {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              focused = rrr.eq(rrr.index($(self.focusset)) + 3);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          }
        }, 100);
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          // this.datas.summa -= this.prsearch[index].debit_summa;
          // this.datas.initial_balance_table.splice(index, 1);
          // console.log(this.prsearch[index]);
          let indexone=this.datas.initial_balance_table.findIndex(x => x.product_id ===this.prsearch[index].product_id);
          this.datas.initial_balance_table.splice(indexone, 1);
          // this.prsearch.splice(index, 1);
          this.Summa();
        }
      },
      Productchange(index) {
        let self = this;
        var item = self.prsearch[index];
        axios({
          method: "post",
          url: "api/v1/product/price-balance",
          data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          console.log('productchange');
          // item.optom_price = response.data.optom_price;
          // item.chakana_price = response.data.chakana_price;
          // item.debit_price = response.data.body_price;
          if (self.datas.pay_type_id == 3) {
            item.current_balance = response.data.balance;
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              item.optom_price = response.data.optom_price;
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              item.chakana_price = response.data.chakana_price;
            }
            if (response.data.price_type == 2) {
              item.debit_price = response.data.body_price;
            } else if (response.data.price_type == 1) {
              item.debit_price = response.data.body_price / self.datas.dollar_rate;
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
          } else {
            item.current_balance = response.data.balance;
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              // item.optom_dollar_price = response.data.optom_price/self.datas.dollar_rate;
              item.optom_price = response.data.optom_price;
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              // item.chakana_dollar_price = response.data.chakana_price/self.dollar_rate;
              item.chakana_price = response.data.chakana_price;
            }
            if (response.data.price_type == 1) {
              item.debit_price = response.data.body_price;
            } else if (response.data.price_type == 2) {
              item.debit_price = response.data.body_price * self.datas.dollar_rate;
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
          }
          setTimeout(() => {
            self.Changeprice(index);
          }, 100);
            axios({
              method: "get",
              url: "api/v1/product/id/" + item.product_id
            }).then(function (response) {
              item.pack_norma=response.data.pack_count;
              item.product={extra_name:response.data.extra_name};
              if (response.data.shtrix_table[0]) {
                item.shtrix_kod = response.data.shtrix_table[0].shtrix_kod;
              }
            });
        });
      },
      Focus() {
        $(".table-input")
          .eq(0)
          .focus();
      },
      Shtrix(index) {
        let self = this;
        var shtrix = self.prsearch[index].shtrix_kod;
        axios({
          method: "post",
          url: "api/v1/product/shtrix2/" + shtrix,
          data: { sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          if (!response.data[0]) {
          } else if (response.data[1]) {
            self.settedindex = index;
            self.shtrixlist = response.data;
            self.$bvModal.show("modal-shtrix");
          } else {
            self.prsearch[index].product_id =
              response.data[0].product_id;
            self.Productchange(index);
            var classs = $(":focus");
            var rrr = $("body")
              .find("input,select,textarea,button")
              .filter(":visible");
            var focused = rrr.eq(rrr.index(classs) + 2);
            focused.focus();
          }
        });
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      Changeprice(index) {
        var item = this.prsearch[index];
        item.pack_price=item.debit_price*item.pack_norma;
        let self = this;
        if (item.debit_price != 0) {
          item.debit_summa = item.debit_price * item.count;
        }
        if (self.datas.pay_type_id == 3) {
          if (item.chakana_dollar_price > 0) {
            console.log('changeprice')
            self.Changepricechakanadollar(index);
          }
          if (item.optom_dollar_price > 0) {
            self.Changepriceoptomdollar(index);
          }
        } else {
          if (item.optom_price > 0) {
            this.Changepriceoptom(index);
          }
          if (item.chakana_price > 0) {
            this.Changepricechakana(index);
          }
        }
        this.Summa();
      },
      Changepackprice(index){
        var item = this.prsearch[index];
        if(item.pack_price>0){
          item.debit_price=item.pack_price/item.pack_norma;
          this.Changeprice(index);
        }
      },
      Changecount(index) {
        var item = this.prsearch[index];
        if(item.count>0){
        item.pack_count=item.count/item.pack_norma;
        }
        if (item.debit_price > 0) {
          item.debit_summa = item.count * item.debit_price;
          this.Changepricechakana(index);
          this.Changepriceoptom(index);
        }
        if (item.optom_price > 0) {
          item.optom_summa = item.count * item.optom_price;
        }
        if (item.chakana_price > 0) {
          item.chakana_summa = item.count * item.chakana_price;
        }
        this.Summa();
      },
      Changepack(index) {
        var item = this.prsearch[index];
          item.count=item.pack_count*item.pack_norma;
          this.Changecount(index);
      },
      Changepercentoptom(index) {
        var item = this.prsearch[index];
        var percent = this.toNum(item.optom_percent);
        if (this.datas.pay_type_id == 3) {
          item.optom_dollar_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
          item.optom_summa = item.optom_price * item.count;
        } else {
          item.optom_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.optom_summa = item.optom_price * item.count;
          item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
        }
      },
      Changepercentchakana(index) {
        var item = this.prsearch[index];
        var percent = this.toNum(item.chakana_percent);
        if (this.datas.pay_type_id == 3) {
          item.chakana_dollar_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
          item.chakana_summa = item.chakana_price * item.count;
        } else {
          item.chakana_price = this.toNum(item.debit_price) * (percent / 100 + 1);
          item.chakana_summa = item.chakana_price * item.count;
          item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
        }
      },
      Changepriceoptom(index) {
        var item = this.prsearch[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
            item.optom_percent = this.calculateMarkupPercent(item.optom_dollar_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_percent = this.calculateMarkupPercent(item.optom_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
          }
        }
      },
      Changepriceoptomdollar(index) {
        // this.ChangedAndAdd(index);
        var item = this.prsearch[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = this.calculateMarkupPercent(item.optom_dollar_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = this.calculateMarkupPercent(item.optom_price, item.debit_price);
            item.optom_summa = item.optom_price * item.count;
          }
        }
      },
      Changepricechakana(index) {
        var item = this.prsearch[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_dollar_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
            item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
          }
        }
      },
      Changepricechakanadollar(index) {
        var item = this.prsearch[index];
        console.log('chakanadollar');
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_dollar_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = this.calculateMarkupPercent(item.chakana_price, item.debit_price);
            item.chakana_summa = item.chakana_price * item.count;
          }
        }
      },
      calculateMarkupPercent(salePrice, costPrice) {
        const sale = this.toNum(salePrice);
        const cost = this.toNum(costPrice);
        if (cost <= 0) return 0;
        return Number(((sale - cost) / cost * 100).toFixed(2));
      },
      Addtable() {
        this.datas.initial_balance_table.push({
          product: null,
          shtrix_kod: "",
          product_id: 0,
          count: 0,
          debit_price: 0,
          chakana_percent: 0,
          optom_percent: 0,
          chakana_price: 0,
          optom_price: 0,
          chakana_summa: 0,
          optom_summa: 0,
          debit_summa: 0,
          pack_count:0,
          pack_price:0,
          pack_norma:0,
          product:{extra_name:""}
        });
        this.Tablefocus();
      },
      Summa() {
        this.datas.summa = 0;
        this.datas.count_all = 0;
        let self = this;
        this.datas.initial_balance_table.forEach(function (key, value) {
          self.datas.summa += key.debit_summa;
          self.datas.count_all += key.count;
        });
      },
      Savedokument(type = 'default') {
        let self = this;
        // if (self.rule.open == true) {
          if (this.$route.path == "/initial/create") {
            var methods = "post";
            var action = "api/v1/initial-balance";
            self.changedisabled = false;
          } else {
            var methods = "patch";
            var action = "api/v1/initial-balance/id/" + self.$route.params.id;
          }
          if (self.changedisabled == false) {
            if(self.sending==false){
              self.sending = true;
            self.datas.updated_at = new Date()
              .valueOf()
              .toString()
              .slice(0, 10);
            axios({
              method: methods,
              url: action,
              data: self.datas
            }).then(function (response) {
              self.$store.state.saved = 0;
              if (type == 'barcode') {
                let myWindow;
                myWindow = window.open(
                  '#/initial/barcode/' + response.data.id,
                  "_blank",
                  "width=500, height=800"
                );
              } else if (type == 'a4') {
                localStorage.setItem("print_type", "Копия");
                let myWindow;
                myWindow = window.open(
                  '#/initial/a4print/' + response.data.id,
                  "_blank",
                  "width=500, height=800"
                );
                self.$router.push({ name: "Начальный остаток" });
              } else {
                self.$router.push({ name: "Начальный остаток" });
              }
              self.sending = false;
            }).catch(function(error){
              self.sending = false;
            });
            }
          }else{
            self.$router.push({ name: "Начальный остаток" });
          }
          // } else {
          //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
          // }
        }
      },
      computed: {
        filterlist() {
          if (this.datas.initial_balance_table) {
            return this.datas.initial_balance_table.slice(0, this.limits);
          }
        },
        prsearch() {
        var data = [];
        if (this.datas.initial_balance_table[0]) {
          if (this.datas.initial_balance_table[0].product) {
            data = this.datas.initial_balance_table.filter(row => {
              const name = row.product.extra_name.toString().toLowerCase();
              const searchTerm = this.filter2.toLowerCase();
              return name.includes(searchTerm);
            }).slice(0, self.limits);
          } 
        }
        return data;
      },
        filteredRows() {
          return this.shtrixlist.filter(row => {
            const name = row.name.toString().toLowerCase();
            const searchTerm = this.filter.toLowerCase();

            return name.includes(searchTerm);
          });
        }
      }
    };
</script>